<template>
  <v-flex md12 mb-4>
      <div class="mod-name">
        <p class="font-red">{{temaName}}</p>
      </div>
    </v-flex>
</template>
<script>
export default {
  computed: {
    temaName() {
      return this.$store.state.tema;
    }
  }
}
</script>



// WEBPACK FOOTER //
// Nombretema.vue?a4599172